/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
import React from 'react';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import { FieldArray, Form, Formik } from 'formik';
import { CardContent } from '@mui/material';
import InputGroup from './components/InputGroup';
import GroupButton from 'components/Buttons/ButtonGroup';
import { usePopulation } from 'hooks/usePopulation';
import { populationSchema } from './schemas';
import { useStyles } from 'components/Styles';
import {
  adjustSizeRemain,
  availableLots,
  availablePondCycles,
  quantityParsed,
} from './helpers';

const emptyPopulation = {
  cycle: '',
  lot: '',
  quantity: '',
  size_remain: '',
  date: new Date().toUTCString(),
};

function Population() {
  const classes = useStyles();
  const {
    lots,
    setLots,
    pondCycles,
    setPondCycles,
    request,
    openProgress,
    id,
    location,
    disable,
  } = usePopulation();

  const initialValues = {
    populations: [emptyPopulation],
  };

  const handleSubmit = (values) => {
    const quantityIsGreaterThanTheRemainingBatchSize = values.populations.some(
      (item) => quantityParsed(item.quantity) > item.size_remain
    );

    if (quantityIsGreaterThanTheRemainingBatchSize) return;

    const payload = values.populations.map((item) => ({
      cycle: item.cycle,
      lot: item.lot,
      date: item.date,
      quantity: quantityParsed(item.quantity),
    }));

    request(payload);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={populationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setValues, setFieldValue }) => {
        const hasPopulation =
          values.populations && values.populations.length > 0;
        const handleAdd = () => {
          setValues({
            ...values,
            populations: [...values.populations, { ...emptyPopulation }],
          });
        };

        adjustSizeRemain([...values.populations]);
        return (
          <ContainerCard loading={openProgress}>
            <Form noValidate>
              <div className={classes.root}>
                <HeaderCard
                  title="Dados do Povoamento"
                  tooltipText="Essa tela tem como objetivo povoar um viveiro a partir
                  de um lote de animais."
                  handleAdd={!id && handleAdd}
                />
                <FieldArray name="populations">
                  {({ remove }) => (
                    <CardContent style={{ padding: '0rem' }}>
                      {hasPopulation &&
                        values.populations.map((_, index) => (
                          <InputGroup
                            key={index}
                            index={index}
                            onRemove={() => remove(index)}
                            disableRemoveButton={
                              values.populations.length === 1
                            }
                            lots={availableLots({ values, lots })}
                            values={values}
                            setValues={setValues}
                            setFieldValue={setFieldValue}
                            setLots={setLots}
                            pondCycles={availablePondCycles({
                              values,
                              pondCycles,
                            })}
                            setPondCycles={setPondCycles}
                            id={id}
                            location={location}
                            sizeArrayValues={values.populations.length}
                          />
                        ))}
                    </CardContent>
                  )}
                </FieldArray>
              </div>
              <GroupButton
                deleteRoute="/populations/"
                routeDelete="/populations"
                returnRoute="/populations"
                id={id}
                disable={disable}
                messageDialogError="Não é possível excluir este povoamento, pois este ciclo possui mortalidade."
                message="A exclusão dessa população pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
              />
            </Form>
          </ContainerCard>
        );
      }}
    </Formik>
  );
}

export default Population;
